import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MORNING_OVERTIME_COMMENT_MAX_LENGTH } from '../../constants/morning-overtime-readiness.constants';
import {
  MorningOvertimeReadinessPromptAnswer,
  MorningOvertimeReadinessPromptViewState
} from '../../models/morning-overtime-readiness.model';

@Component({
  selector: 'app-morning-overtime-prompt',
  templateUrl: './morning-overtime-prompt.component.html',
  styleUrls: ['./morning-overtime-prompt.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MorningOvertimePromptComponent {
  @Input() public viewState: MorningOvertimeReadinessPromptViewState;
  @Output() public submitAnswer: EventEmitter<MorningOvertimeReadinessPromptAnswer>;

  public readonly commentMaxLength: number = MORNING_OVERTIME_COMMENT_MAX_LENGTH;
  public comment: string;

  constructor() {
    this.submitAnswer = new EventEmitter<MorningOvertimeReadinessPromptAnswer>();
    this.comment = '';
  }

  public get isSubmitting(): boolean {
    return !!this.viewState && this.viewState.isSubmitting;
  }

  public get remainingCount(): number {
    return this.commentMaxLength - this.comment.length;
  }

  public get hasFieldError(): boolean {
    return !!this.viewState && !!this.viewState.commentErrorKey;
  }

  public get hasMessage(): boolean {
    return !!this.viewState && !!this.viewState.messageKey;
  }

  public onCommentChange(value: string): void {
    this.comment = value || '';
  }

  public onReadyClick(): void {
    this.emitAnswer(true);
  }

  public onNotReadyClick(): void {
    this.emitAnswer(false);
  }

  private emitAnswer(ready: boolean): void {
    this.submitAnswer.emit({
      ready: ready,
      comment: this.comment
    });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/morning-overtime-readiness/components/morning-overtime-prompt/morning-overtime-prompt.component.ts